const data = () => [
  {
    image: require('./assets/photo/photo_1.png'),
    chat: [],
    buttons: [0, 1, 4],
    rightButton: 1,
    info: 'Молодец! Ты сделал правильный выбор. На этой фотографии нет личной информации и ей можно поделиться с друзьями.',
    errors: [
      { button: 0, title: 'Лучше скрывать личные фотографии от посторонних людей.' },
      { button: 4, title: 'А почему нет? Такой фотографией можно поделиться с друзьями. На ней нет личной информации.' },
    ],
  },
  {
    image: require('./assets/photo/photo_2.png'),
    chat: [],
    buttons: [0, 1, 4],
    rightButton: 4,
    info: 'Верное решение! Лучше не хвастаться дорогими подарками и покупками. Это может привлечь злоумышленников.',
    errors: [
      { button: 0, title: 'Лучше не хвастаться дорогими подарками и покупками. Это может привлечь злоумышленников.' },
      { button: 1, title: 'Лучше не хвастаться дорогими подарками и покупками, даже с друзьями. Это может привлечь злоумышленников.' },
    ],
  },
  {
    image: require('./assets/photo/photo_3.png'),
    chat: [],
    buttons: [0, 1, 4],
    rightButton: 4,
    info: 'Верное решение! Такой фотографией лучше не делиться, так как на ней есть личная информация: переписка в соцсетях, стикер с телефонным номером, стикер с логином и паролем.',
    errors: [
      { button: 0, title: 'Лучше скрывать личные фотографии от посторонних людей.' },
      { button: 1, title: 'Лучше не делиться этой фотографией, даже с друзьями, так как на ней есть личная информация: переписка в соцсетях, стикер с телефонным номером, стикер с логином и паролем. Никогда не храни логин и пароль на стикере или бумажке!' },
    ],
  },
  {
    image: require('./assets/photo/photo_4.png'),
    chat: [
      { author: 'zap', text: 'Привет, Скобец. Классно отметили день рождения!' },
      { author: 'skob', text: 'Привет, Запятыня, это точно! Спасибо за подарок! 😃' },
      { author: 'zap', text: 'Я в телефоне нашла классную фотку, можно я ей поделюсь?' },
      { author: 'zap', text: require('./assets/photo/photo_4_2.png'), type: 'img' },
      { author: 'skob', text: 'Как-то я странно на этой фотке вышел. А есть другая?' },
      { author: 'zap', text: 'Да, как тебе эта?' },
      { author: 'zap', text: require('./assets/photo/photo_4.png'), type: 'img' },
      { author: 'skob', text: 'О! Круто, мы тут такие смешные, её можно показать друзьям!' },
      { author: 'zap', text: 'Круто, тогда выложу её. 😉' },
    ],
    buttons: [0, 1, 3, 4],
    rightButton: 1,
    info: 'Если на фотографии есть другие люди, то обязательно спроси их разрешение, перед тем как опубликовать совместное фото. Что и сделала Запятыня в личной переписке.',
    errors: [
      { button: 0, title: 'Лучше скрывать личные фотографии от посторонних людей.' },
      { button: 3, title: 'Это хорошая идея! Но Запятыня уже спросила разрешение у Скобца и он согласился.' },
      { button: 4, title: 'Почему нет? Хорошая фотография, главное спросить разрешение у друга.' },
    ],
  },
  {
    image: require('./assets/photo/photo_5_2.png'),
    chat: [
      { author: 'zap', text: 'Привет! Отлично погуляли!' },
      { author: 'zap', text: 'Держи фотки!' },
      { author: 'zap', text: require('./assets/photo/photo_5.png'), type: 'img' },
      { author: 'zap', text: require('./assets/photo/photo_5_3.png'), type: 'img' },
      { author: 'zap', text: 'Какая у тебя все-таки классная собака!' },
      { author: 'slash', text: 'Привет, какие отличные фотки, спасибо!' },
      { author: 'slash', text: 'Джеку ты тоже понравилась. Обычно он лает на новых знакомых. 😃' },
      { author: 'zap', text: 'Супер! Эх, когда-нибудь я тоже заведу собаку! 😌' },
      { author: 'zap', text: 'Кстати, забыла спросить, откуда у тебя появился Джек?' },
      { author: 'slash', text: 'Я целый год уговаривал родителей купить щенка, они не соглашались, потому что не верили, что я смогу за ним ухаживать.' },
      { author: 'slash', text: 'Я в течение года делал разные дела по дому, помогал маме с уборкой. И на день рождения мне подарили щенка! 😊 ' },
      { author: 'zap', text: 'Круто, надо тоже так попробовать!' },
    ],
    buttons: [1, 2, 3, 4],
    rightButton: 3,
    info: 'Хорошая идея, так как на фотографии есть другой человек. Сначала запрашиваем разрешение, а потом публикуем фотографию.',
    errors: [
      { button: 1, title: ' Если на фотографии есть другие люди, то обязательно спроси их разрешение, перед тем как опубликовать совместное фото.' },
      { button: 2, title: 'Слеш не просил об этом. Прочитай чат внимательно.\n' },
      { button: 4, title: 'Почему нет? Хорошая фотография, главное спросить разрешение у друга.' },
    ],
  },
  {
    image: require('./assets/photo/photo_6.png'),
    chat: [
      { author: 'zap', text: 'Слэш, привет!' },
      { author: 'zap', text: 'Как тебе вчерашняя тренировка?' },
      { author: 'slash', text: 'Привет, хорошо, но нужно отрабатывать удары.' },
      { author: 'slash', text: 'Пойдем в следующее воскресенье на теннис?' },
      { author: 'zap', text: 'Конечно, соревнования уже на носу!' },
      { author: 'slash', text: require('./assets/thumbs.svg'), type: 'img' },
      { author: 'zap', text: 'Слушай, хочу поделиться со своими друзьями фотографией с прошлой тренировки. Ты не против?' },
      { author: 'zap', text: require('./assets/photo/photo_6.png'), type: 'img' },
      { author: 'slash', text: 'Ммм... Я сейчас скрываю от друзей, что тренируюсь. Хочу сделать для всех сюрприз на соревнованиях.' },
      { author: 'zap', text: 'А если я скрою твое лицо на фотографии? Вот так.' },
      { author: 'zap', text: require('./assets/photo/photo_6_2.jpg'), type: 'img' },
      { author: 'slash', text: 'О, прикольно получилось, так можно! 😃' },
      { author: 'zap', text: 'Спасибо! 😃' },
    ],
    buttons: [1, 2, 3, 4],
    rightButton: 2,
    info: 'Все верно! Слэш попросил закрыть лицо перед публикацией фотографии. Помни, если на фотографии есть другие люди, то обязательно спроси их разрешение, перед тем, как опубликовать совместное фото.',
    errors: [
      { button: 1, title: 'Если на фотографии есть другие люди, то обязательно спроси их разрешение, перед тем как опубликовать совместное фото.' },
      { button: 3, title: 'Запятыня уже получила ответ от Слэша, он ей разрешил, но с одним условием. Читай в чате.' },
      { button: 4, title: 'Почему нет? Хорошая фотография, главное спросить разрешение у друга.\n' },
    ],
  },
]

export default data()
